<template>
    <slot name="filter-field-multioptions-opt" v-bind="this"></slot>
</template>

<script>
export default {
    props: {
        option: { type: Object, required: true },
        name: { type: String, required: true },
        index: { type: Number, required: true }
    },
    data() {
        return {
            checked: this.option.checked || false
        }
    },
    computed: {
        isActive() {
            const subs = Array.isArray(this.option.suboptions)
                ? this.option.suboptions
                : []
                return this.checked || subs.some(c => c.checked)
        }
    },
    methods: {
        change() {
            this.checked = !this.checked
            this.option.checked = this.checked
            if (Array.isArray(this.option.suboptions)) {
                this.option.suboptions.forEach(child => {
                child.checked = this.checked
                })
            }
            this.$emit('change', this.option)
        },
        childChanged(updatedChild) {
            this.option.suboptions = this.option.suboptions.map(child =>
            child.value === updatedChild.value ? updatedChild : child)
            this.$emit('change', this.option)
        }
    }
}
</script>

